const translations = {
  "en": {
    "Add your holdings so Edggy can start building around you. Edggy will learn to think like you, and get smarter to keep you unstoppable.": "Add your holdings so Edggy can start building around you. Edggy will learn to think like you, and get smarter to keep you unstoppable.",
    "All Your Accounts, All in One Place": "All Your Accounts, All in One Place",
    "and Unlock Portfolio Syncing": "and Unlock Portfolio Syncing",
    "Become": "Upgrade",
    "Become PRO": "Upgrade",
    "Connect your favorite platforms effortlessly and stop switching between different apps.": "Connect your favorite platforms effortlessly and stop switching between different apps.",
    "Get Asset Analysis": "Get Asset Analysis",
    "Import Portfolio Now": "Import Portfolio Now",
    "PRO": "Account",
    "See your wealth grow with intuitive charts and get a personalized summary of your portfolio every day.": "See your wealth grow with intuitive charts and get a personalized summary of your portfolio every day.",
    "Smart Insights at a Glance": "Smart Insights at a Glance",
    "Sync Your Accounts": "Sync Your Accounts"
  },
  "zh-tw": {
    "Add your holdings so Edggy can start building around you. Edggy will learn to think like you, and get smarter to keep you unstoppable.": "新增你的持倉，讓 Edggy 開始圍繞你進行建構。Edggy 將學會以你的方式思考，並變得更聰明，讓你始終無可阻擋。",
    "All Your Accounts, All in One Place": "所有帳戶，盡收一處",
    "and Unlock Portfolio Syncing": "並解鎖投資組合同步功能",
    "Become": "升級",
    "Become PRO": "升級",
    "Connect your favorite platforms effortlessly and stop switching between different apps.": "輕鬆連接你最愛的平台，不必再在不同 App 之間切換。",
    "Get Asset Analysis": "取得資產分析",
    "Import Portfolio Now": "立即匯入投資組合",
    "PRO": "帳號",
    "See your wealth grow with intuitive charts and get a personalized summary of your portfolio every day.": "透過直觀圖表看著財富成長，每天獲得個人化的投資組合摘要。",
    "Smart Insights at a Glance": "一目了然的智慧洞察",
    "Sync Your Accounts": "同步你的帳戶"
  }
};

export default translations;
